// import logo from './logo.svg';
import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/navbar';
import Footer from './components/footer';

import HomePage from './pages/index';
import AuthPage from './pages/signin';
import Profile from './pages/profile';
import Monitoring from './pages/monitoring';
import Upload from './pages/upload';
import Analysis from './pages/analysis';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <div className="App">

        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

          <Router>

            <Navbar />

            <Routes>
              {/* All routes accessible without authentication */}
              <Route path="/" element={<HomePage />} />
              <Route path="/signin" element={<AuthPage />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/monitoring" element={<Monitoring />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/analysis" element={<Analysis />} />
              
              {/* Fallback route */}
              <Route path="*" element={<Route to="/" />} />

            </Routes>

            <Footer />

          </Router>

        </div>

      </div>
    </AuthProvider>
  );
}

export default App;

